import { ObjectType, Field, InputType, Int, ID } from 'type-graphql'

import { ScalarObject } from '@things-factory/shell'
import { Theme } from './theme.js'

@InputType({ description: 'Input for creating a new theme.' })
export class NewTheme {
  @Field({ description: 'The name for the new theme.' })
  name: string

  @Field({ nullable: true, description: 'A detailed description for the new theme.' })
  description?: string

  @Field({ nullable: true, description: 'Whether the new theme should be active upon creation.' })
  active?: boolean

  @Field({ nullable: true, description: 'The type of the new theme.' })
  type?: string

  @Field(type => ScalarObject, { nullable: true, description: 'A JSON object of style values for the new theme.' })
  value?: any
}

@InputType({ description: 'Input for updating (patching) an existing theme.' })
export class ThemePatch {
  @Field(type => ID, { nullable: true, description: 'The unique identifier of the theme to update.' })
  id?: string

  @Field({ nullable: true, description: 'The new name for the theme.' })
  name?: string

  @Field({ nullable: true, description: 'The new description for the theme.' })
  description?: string

  @Field({ nullable: true, description: 'The new active status for the theme.' })
  active?: boolean

  @Field({ nullable: true, description: 'The new type for the theme.' })
  type?: string

  @Field(type => ScalarObject, { nullable: true, description: 'The new JSON object of style values for the theme.' })
  value?: any

  @Field({ nullable: true, description: 'A flag indicating whether the theme is being created, updated, or deleted.' })
  cuFlag?: string
}

@ObjectType({ description: 'A paginated list of themes.' })
export class ThemeList {
  @Field(type => [Theme], { description: 'The list of theme items.' })
  items: Theme[]

  @Field(type => Int, { description: 'The total number of themes.' })
  total: number
}
